import { hubApplication } from './hub';
import { lensApplication } from './lens';
import { pixelRadApplication } from './pixel-rad';
import { therapiesSitesApplication } from './therapies-sites';
import { therapiesSponsorsApplication } from './therapies-sponsors';
import { trialsApplication } from './trials-app';
import { davidApplication } from './david';

export const APPLICATIONS = [
  hubApplication,
  lensApplication,
  pixelRadApplication,
  therapiesSitesApplication,
  therapiesSponsorsApplication,
  trialsApplication,
  davidApplication,
];
